import { render } from "./TokenNewsFeed.vue?vue&type=template&id=a9e96262&scoped=true"
import script from "./TokenNewsFeed.vue?vue&type=script&lang=js"
export * from "./TokenNewsFeed.vue?vue&type=script&lang=js"

import "./TokenNewsFeed.vue?vue&type=style&index=0&id=a9e96262&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e96262"],['__file',"resources/js/components/TokenNewsFeed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9e96262"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9e96262', __exports__)) {
    api.reload('a9e96262', __exports__)
  }
  
  module.hot.accept("./TokenNewsFeed.vue?vue&type=template&id=a9e96262&scoped=true", () => {
    api.rerender('a9e96262', render)
  })

}


export default __exports__